import { useDispatch, useSelector } from "react-redux";
import { visualizerActions, uiActions } from "../../store";

import styles from "./StepsController.module.css";
import arrowLeft from './assets/arrowLeft.svg';
import arrowRight from './assets/arrowRight.svg';
import { useNavigate } from "react-router-dom"
import { useParams } from 'react-router-dom';

export default function StepsController() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const urlParams = useParams();


    const floorPlanSteps = useSelector((state) => state.visualizer.activeFloorPlanSteps);
    const activeStep = useSelector((state) => state.visualizer.activeStep);
    const activePlan = useSelector((state) => state.visualizer.activeFloorPlanData);
    const isLoading = useSelector((state) => state.ui.vizLoading);

    if(floorPlanSteps === undefined) return false;


    if(urlParams.area !== activeStep.area) {
        dispatch(visualizerActions.setActiveStep(floorPlanSteps.filter(step => step.area === urlParams.area)[0]));
    }

    const activeStepIndex = floorPlanSteps.findIndex(step => step.id === activeStep.id);
    let prevStep = floorPlanSteps[activeStepIndex-1];
    let nextStep = floorPlanSteps[activeStepIndex+1];


    const gotoPrevStep = () => {
        if(urlParams.area !== prevStep.area){
            navigate(`/visualizer/floorplan/${activePlan["id"]}/area/${prevStep.area}/spec/${encodeURIComponent(activePlan[prevStep.area])}/sel/${activePlan[prevStep.area+"Sel"]}`);
            dispatch(uiActions.setVizLoading(true));
        } 
        if(!isLoading)
            dispatch(visualizerActions.setActiveStep(prevStep));
    }

    const gotoNextStep = () => {
        
        if(urlParams.area !== nextStep.area){
            navigate(`/visualizer/floorplan/${activePlan["id"]}/area/${nextStep.area}/spec/${encodeURIComponent(activePlan[nextStep.area])}/sel/${activePlan[nextStep.area+"Sel"]}`);
            dispatch(uiActions.setVizLoading(true));
        } 

        if(!isLoading)
            dispatch(visualizerActions.setActiveStep(nextStep));
    }

    return (
        <div className={styles.content}>
            <div className={styles.stepController}>
                {prevStep &&
                    <div className={styles.stepsLeft}>
                        <button 
                            className={styles.arrowLeft} 
                            onClick={gotoPrevStep} 
                            disabled={isLoading} 
                        >
                            <img src={arrowLeft} alt="Arrow Left" />
                        </button>
                        <div className={styles.previous}>Previous<span>{prevStep.step}</span></div>
                    </div>
                }

                <div className={styles.stepsMid}>
                    <div className={styles.step}>{activeStep.step}</div>
                </div>

                {nextStep &&
                    <div className={styles.stepsRight}>
                        <div className={styles.next}>Next<span>{nextStep.step}</span></div>
                        <button 
                            className={styles.arrowRight} 
                            onClick={gotoNextStep} 
                            disabled={isLoading} 
                        >
                            <img src={arrowRight} alt="Arrow Right" />
                        </button>
                    </div>
                }
            </div>
        </div>
    );

}